module.exports = __webpack_public_path__ + "static/media/1.0e3f4169.jpg";